module.exports = __webpack_public_path__ + "img/lottery_320.6668fdb3.png";